import * as conversationRuleset from './conservation.ruleset';
import { conversationSchema } from './conversation.schema';
import { Immutable } from '@play-co/replicant';
import { conversationGetters } from './conversation.getters';
import * as petRuleset from '../buruburu/pet/pet.ruleset';
// import { Pet } from '../buruburu/pet';
import { conversationModifiers } from './conversation.modifiers';
import { conversationActions } from './conversation.actions';
import { Profile } from '../profile';
import { Visit } from '../visit';
import { ReplicantModuleState } from '../utils';
import { petSchema } from '../buruburu/pet/pet.schema';
import { VisitRecord } from '../visit/record';
import { Duo } from '../duo';

namespace Pet {
  export const schema = petSchema({ ruleset: petRuleset });
}

export type Conversation = typeof Conversation;
// eslint-disable-next-line no-redeclare
export namespace Conversation {
  export const $DEPENDENCIES = {
    Pet,
    Profile,
    Visit,
    VisitRecord,
    Duo,
  };

  export const ruleset = conversationRuleset;
  export const schema = conversationSchema;
  export const getters = conversationGetters(Conversation, $DEPENDENCIES);
  export const modifiers = conversationModifiers;
  export const actions = conversationActions(Conversation);

  export type MutableState = ReplicantModuleState<Conversation>;
  export type State = Immutable<MutableState>;
}
